import { useState, useEffect } from "react";
import { api, apiErr } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Bike, Loader2 } from "lucide-react";
import DeliveryZones from "@/components/owner/DeliveryZones";

export default function DeliverySettings({ resto, onSaved }) {
  const [fee, setFee] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (resto) setFee(String(resto.delivery_fee ?? 0));
  }, [resto]);

  const save = async () => {
    const value = parseFloat(fee);
    if (isNaN(value) || value < 0) { toast.error("Ingresa un precio válido"); return; }
    setSaving(true);
    try {
      await api.put("/owner/delivery", { delivery_fee: value });
      toast.success("Costo de envío actualizado");
      onSaved && onSaved();
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl space-y-6">
      <div className="rounded-2xl border border-neutral-200 bg-white p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-11 h-11 rounded-xl bg-neutral-100 flex items-center justify-center">
            <Bike className="w-5 h-5 text-neutral-700" />
          </div>
          <div>
            <h3 className="font-admin font-bold text-lg">Costo de envío</h3>
            <p className="text-sm text-neutral-500">Se suma a todos los pedidos de tu app.</p>
          </div>
        </div>

        <Label htmlFor="delivery-fee">Precio por delivery</Label>
        <div className="flex items-center gap-2 mt-1.5">
          <div className="relative flex-1">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400">$</span>
            <Input id="delivery-fee" type="number" min="0" step="0.01" value={fee}
              onChange={(e) => setFee(e.target.value)} className="pl-7" data-testid="delivery-fee-input" />
          </div>
          <Button onClick={save} disabled={saving} data-testid="delivery-fee-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Guardar"}
          </Button>
        </div>
        <p className="text-xs text-neutral-400 mt-3">
          Pon <b>0</b> si no cobras envío. El costo de envío va íntegro a tu restaurante (sin comisión de plataforma).
        </p>
      </div>
      <DeliveryZones />
    </div>
  );
}
